import React, { useContext, useEffect, useState } from "react";
// import USER from "components/context/UserContext";
// import { server_api } from "config/config";
// import axios from "axios";
import "animate.css";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Grid from "./Grid";
import Clubs from "data/Clubs.json";
import Loading from "components/loadings/Loading";
import EventDetails from "./EventDetails";
// import CheckoutBtn from "./CheckoutBtn";
import { getDataArray } from "utils/eventDataArray";
import { useSearchParams } from "react-router-dom";
// import AdminBtn from "components/admin/AdminBtn";
import GridItem from "./GridItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClubDetails from "./ClubDetails";
import FooterDev from "components/footer/FooterDev";
import Comingsoon from "./comingsoon/Comingsoon";
import ScheduleBtn from "./ScheduleBtn";
import { getClubEvents } from "utils/fetchEvents";

export default function Events() {
  // const { user } = useContext(USER);
  const [searchParams, setSearchParams] = useSearchParams();
  const [DATA, SETDATA] = useState(getDataArray(Clubs, "club"));
  const [curData, setCurData] = useState("clubs");
  const [loading, setLoading] = useState(false);
  const [selectedClub, setSelectedClub] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [REGISTERED_EVENTS, SET_REGISTERED_EVENTS] = useState([]);

  // useEffect(() => {
  //   if (user.isLoggedIn && user.data?.registeredEvents) {
  //     SET_REGISTERED_EVENTS(user.data.registeredEvents);
  //   }
  // }, [user]);

  useEffect(() => {
    const club = Clubs.find((item) => item.name === searchParams.get("club"));
    const eventCode = searchParams.get("event");

    if (eventCode) {
      // if event-key present
      setSelectedEvent(eventCode);
      setShowDetails(true);
    } else if (showDetails) {
      // if event-key absent and showDetails is true
      setSelectedEvent(null);
      setShowDetails(false);
    }

    if (!club) {
      // if club-key present but invalid value (club doesn't exists)
      if (searchParams.get("club")) {
        searchParams.delete("club");
        searchParams.delete("event");

        setSearchParams(searchParams);
      }

      setCurData("clubs");
      setSelectedClub(null);
      SETDATA(getDataArray(Clubs, "club"));

      return;
    }

    if (selectedClub !== club.title) {
      // if club exists and different is selected
      setSelectedClub(club.title);
      getEvents(club.name);
    }

    // eslint-disable-next-line
  }, [searchParams]);

  async function getEvents(clubname) {
    setLoading(true);

    // const res = await axios({
    //   method: "GET",
    //   baseURL: server_api,
    //   url: `events?club=${clubname}&eventType=EDGE`,
    // }).catch((err) => {
    //   console.log(err);
    // });
    const res = getClubEvents(clubname);

    // console.log(res);

    if (res?.data?.success) {
      const arr = getActiveEvent(res.data.events);
      // console.log(arr);
      if (arr?.length > 0) SETDATA(getDataArray(arr, "event"));
      else SETDATA([]);
    }
    setLoading(false);
    setCurData("events");

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  function closeModal() {
    searchParams.delete("event");
    setSearchParams(searchParams);
  }

  function goBackHandler() {
    setSelectedClub(null);
    searchParams.delete("club");
    setSearchParams(searchParams);
  }

  return (
    <>
      <div className="w-full h-full min-h-screen py-3 sm:py-4 px-3 sm:px-8">
        <div className="text-white flex items-center justify-center mb-4">
          {curData !== "clubs" && (
            <button
              title="Back"
              className="text-gray-300 text-3xl sm:text-4xl rounded mr-4 drop-shadow-[0_0_0.3rem_red] transition-all min-w-max flex align-center"
              onClick={goBackHandler}
            >
              <ArrowBackIcon fontSize="inherit" />
            </button>
          )}

          {curData === "clubs" && (
            <h2 className="font-black-hawk text-5xl font-normal py-4">
              <span className="text-red">C</span>lubs
            </h2>
          )}

          {curData === "events" && (
            <h2 className="font-black-hawk text-2xl md:text-4xl py-2 grow text-center pr-8">
              <span className="text-red">E</span>vents |{" "}
              {selectedClub && (
                <>
                  {selectedClub.split(" ")?.map((word, _idx) => {
                    return (
                      <span key={_idx.toString()}>
                        <span className="text-red">{word.slice(0, 1)}</span>
                        <span>{word.slice(1)}</span>{" "}
                      </span>
                    );
                  })}
                </>
              )}
            </h2>
          )}
        </div>

        {DATA?.length > 0 ? (
          <TransitionGroup component={Grid}>
            {DATA.map((item) => {
              return (
                <CSSTransition
                  key={item._id}
                  timeout={900}
                  classNames="hex-transition"
                >
                  <GridItem data={item} />
                </CSSTransition>
              );
            })}
          </TransitionGroup>
        ) : (
          <Comingsoon />
        )}

        {loading && !showDetails && <Loading />}

        <CSSTransition
          in={showDetails}
          appear={false}
          timeout={500}
          classNames="details"
          unmountOnExit
        >
          <EventDetails
            eventCode={selectedEvent}
            close={closeModal}
            registered={REGISTERED_EVENTS.includes(selectedEvent)}
          />
        </CSSTransition>

        {/* <CheckoutBtn /> */}

        {/* {user.data?.isAdmin && <AdminBtn />} */}
      </div>

      {selectedClub && <ClubDetails selectedClub={selectedClub} />}

      {!selectedClub && !selectedEvent && <ScheduleBtn />}

      {!selectedClub && <FooterDev />}
    </>
  );
}

const getActiveEvent = (events) => {
  if (!events) return [];

  return events;
};
